{
  "title": "Title",
  "shot": "Shot",
  "date": "Date",
  "talent": "Talent",
  "shot_file": "Fichier du rush",
  "shot_file_cover": "Couveture du rush",
  "rush_submit": "Ajouter rush"
}
